var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-transition-slide',{attrs:{"active":_vm.showAlerts},on:{"opened":_vm.maybeScrollToAlerts}},[_c('div',{ref:"alerts"},[_c('core-alerts',{attrs:{"alerts":_vm.alerts}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }